import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/atc/ATC CREAM mango.png";
import BiscuitImg from "../../../assets/products/atc/ATC-Mango.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 125,
  },
  {
    grams: 150,
  },
];

export default function MangoATCProduct() {
  return (
    <>
      <Helmet>
        <title>
          ATC Mango Cream Biscuit – BearBitz | Premium Biscuits & Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz ATC Mango Cream Biscuits — tropical mango-flavored cream biscuits in ATC format. View pack sizes and global specifications."
        />
        <meta
          name="keywords"
          content="ATC Mango Cream Biscuit, BearBitz ATC Mango"
        />
        <link rel="canonical" href="/atc/mango" />
        <meta
          property="og:title"
          content="ATC Mango Cream Biscuit – BearBitz"
        />
        <meta
          property="og:description"
          content="Mango cream biscuit in ATC format with export-ready packaging and premium flavor."
        />
      </Helmet>

      <ProductTemplate
        productTitle="MANGO"
        productImage={BisImg}
        description="Sweet Layers of Joy.Crunchy biscuits filled with rich cream—classic favorites in The rich taste of ATC Cream Biscuits, where every crunchy bite meets a smooth and creamy filling."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#FF8D00"
        sectionBgColor="#FFEFC2"
        productBgcolor="#FFE18F"
        tableheadBgcolor="#FF8D00"
        tableBgcolor="#FFF7E2"
        footerBgcolor="#FF8D00"
      />
    </>
  );
}
